import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Client } from '../interfaces/clients';
@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private http: HttpClient) { }
  getById(id: number): Observable<Client> {
    return this.http.get<Client>(`${environment.Server_URL}/clients/${id}`);
  }
  create(client: FormData): Observable<Client> {
    return this.http.post<Client>(`${environment.Server_URL}/clients`, client);
  }
  update(id: number, client: FormData): Observable<Client> {
    return this.http.post<Client>(`${environment.Server_URL}/clients/${id}/update`, client);
  }
  // client.service.ts
  updateStatus(id: number, status: number) {
    return this.http.patch<any>(`${environment.Server_URL}/clients/${id}/status`, { status });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/clients/${id}`);
  }
  getAll(perpage: number, page: number): Observable<any> {
    return this.http.get<any>(`${environment.Server_URL}/clients?per_page=${perpage}&page=${page}`);
  }
   searchClients(serachkey: any): Observable<any> {
      const params = new HttpParams().set('q', serachkey);
     return this.http.get(`${environment.Server_URL}/clients/search`, { params });
   }
   getByVisaType(visaType: number, perPage: number = 10, page: number = 1): Observable<any> {
  const params = new HttpParams()
    .set('status', visaType.toString())
    .set('per_page', perPage.toString())
    .set('page', page.toString());

  return this.http.get<any>(`${environment.Server_URL}/clients/by-visa-type`, { params });
}

}
